<template>
  <v-dialog
    v-model="dialog"
    width="700"
    :fullscreen="$vuetify.display.smAndDown"
  >
    <v-card>
      <v-card-title class="redColor text-white">
        <span class="headline">{{ $t("sales.actions.return_part") }}</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row no-gutters>
            <v-col cols="12" class="mb-1">
              <v-alert
                :model-value="switchI"
                type="error"
                variant="tonal"
                border="bottom"
              >
                <v-row class="pa-3">
                  {{ $t("return_sold_item") }}
                </v-row>
              </v-alert>
            </v-col>
            <v-col cols="12">
              <v-alert
                :model-value="alert.value"
                type="warning"
                variant="tonal"
                border="bottom"
              >
                <v-row align="center" class="py-1">
                  <v-col cols="12" sm="8">
                    {{ alert.message }}
                  </v-col>
                  <v-col cols="12" sm="4">
                    <!-- Mobile: stacked full-width buttons -->
                    <div class="d-flex d-sm-none flex-column ga-2 mt-2">
                      <v-btn
                        variant="outlined"
                        color="success"
                        block
                        @click="((confirm = true), (alert.value = false))"
                      >
                        {{ $t("sales.actions.alert.yes") }}
                      </v-btn>
                      <v-btn
                        variant="outlined"
                        color="error"
                        block
                        @click="((confirm = false), (alert.value = false))"
                      >
                        {{ $t("sales.actions.alert.no") }}
                      </v-btn>
                    </div>
                    <!-- Desktop: unchanged inline buttons -->
                    <v-row class="d-none d-sm-flex mt-2">
                      <v-btn
                        variant="outlined"
                        size="small"
                        color="success"
                        class="mx-1"
                        @click="((confirm = true), (alert.value = false))"
                      >
                        {{ $t("sales.actions.alert.yes") }}
                      </v-btn>
                      <v-btn
                        variant="outlined"
                        size="small"
                        color="error"
                        class="mx-1"
                        @click="((confirm = false), (alert.value = false))"
                      >
                        {{ $t("sales.actions.alert.no") }}
                      </v-btn>
                    </v-row>
                  </v-col>
                </v-row>
              </v-alert>
            </v-col>
            <v-col cols="12" sm="6">
              <v-switch
                v-model="switchI"
                :label="$t('sales.actions.inventory')"
                color="success"
              />
            </v-col>
            <v-col cols="12" sm="6">
              <v-switch
                v-model="switchD"
                :label="$t('sales.actions.damaged')"
                color="orange"
              />
            </v-col>
            <v-col v-if="switchI || switchD" cols="12">
              <v-textarea
                v-model="notes"
                :label="$t('sales.actions.notes')"
                flat
                color="red"
              />
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <!-- Desktop: unchanged horizontal actions -->
      <v-card-actions class="d-none d-md-flex">
        <v-spacer />
        <v-btn color="red-darken-1" variant="outlined" @click="close">
          {{ $t("sales.actions.close") }}
        </v-btn>
        <v-btn
          v-if="switchI"
          :loading="loading"
          :disabled="!confirm"
          color="success"
          variant="outlined"
          @click="inventory"
        >
          {{ $t("sales.actions.inventory") }}
        </v-btn>
        <v-btn
          v-if="switchD"
          :loading="loading"
          :disabled="!confirm"
          color="orange"
          variant="outlined"
          @click="damaged"
        >
          {{ $t("sales.actions.damaged") }}
        </v-btn>
      </v-card-actions>

      <!-- Mobile: stacked full-width buttons -->
      <div class="d-flex d-md-none flex-column ga-2 px-4 pb-4 pt-2">
        <v-btn
          v-if="switchI"
          block
          :loading="loading"
          :disabled="!confirm"
          color="success"
          variant="outlined"
          @click="inventory"
        >
          {{ $t("sales.actions.inventory") }}
        </v-btn>
        <v-btn
          v-if="switchD"
          block
          :loading="loading"
          :disabled="!confirm"
          color="orange"
          variant="outlined"
          @click="damaged"
        >
          {{ $t("sales.actions.damaged") }}
        </v-btn>
        <v-btn color="red-darken-1" variant="outlined" block @click="close">
          {{ $t("sales.actions.close") }}
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import putRequest from "../../api/putRequest";

export default {
  data: () => ({
    loading: false,
    dialog: false,
    switchI: false,
    switchD: false,
    alert: {
      value: false,
      message: "",
    },
    confirm: false,
    data: {},
    notes: "",
  }),
  watch: {
    dialog(value) {
      if (!value) {
        this.data = {};
        this.$emit("close");
      }
    },
    switchI(value) {
      if (value) {
        this.switchD = false;
        this.confirm = false;
        this.alert.value = true;
        this.alert.message = this.$t("sales.actions.alert.inventory_message");
      } else {
        this.switchD = true;
      }
    },
    switchD(value) {
      if (value) {
        this.switchI = false;
        this.confirm = false;
        this.alert.value = true;
        this.alert.message = this.$t("sales.actions.alert.damaged_message");
      } else {
        this.switchI = true;
      }
    },
  },
  methods: {
    open(data) {
      this.data = data;
      this.dialog = true;
    },
    close() {
      this.dialog = false;
      this.data = {};
      this.$emit("close");
    },
    inventory() {
      this.loading = true;
      putRequest(
        `/sale/inventory/${this.data._id}`,
        `user_id=${this.$store.getters.userId}&institution_id=${
          this.$store.getters.institutionId
        }&notes=${this.notes}`,
      )
        .then((response) => {
          this.loading = false;
          this.close();
        })
        .catch(() => {
          this.loading = false;
          this.close();
        });
    },
    damaged() {
      this.loading = true;
      putRequest(
        `/sale/damaged/${this.data._id}`,
        `user_id=${this.$store.getters.userId}&institution_id=${
          this.$store.getters.institutionId
        }&notes=${this.notes}`,
      )
        .then((response) => {
          this.loading = false;
          this.close();
        })
        .catch(() => {
          this.loading = false;
          this.close();
        });
    },
  },
};
</script>
